export class GeoPuntPoiProvider {
    constructor(settings) {
        this.apiRoot = "https://poi.api.geopunt.be/v1/core";
        this.name = "crab";
        this.settings = settings !== null && settings !== void 0 ? settings : {
            maxCount: 2
        };
        console.log(this.settings);
    }
    async forward(query, options) {
        const url = `${this, this.apiRoot}?Theme=Onderwijs&SrsOut=4326&Keyword=${query.string}`;
        const r = await fetch(url, {
            signal: options === null || options === void 0 ? void 0 : options.signal
        });
        const response = await r.json();
        const results = [];
        if (response.pois) {
            response.pois.forEach(l => {
                if (results.length >= this.settings.maxCount)
                    return;
                const location = l.location.points[0].Point.coordinates;
                const description = `${l.labels[0].value}, ${l.location.address.street} ${l.location.address.streetnumber} ${l.location.address.postalcode} ${l.location.address.municipality}`;
                results.push({
                    description: description,
                    location: {
                        lng: location[0],
                        lat: location[1]
                    },
                    type: "school",
                    score: 80,
                    provider: this.name,
                    raw: l
                });
            });
        }
        return results;
    }
    reverse(l, callback) {
        return callback([]);
    }
}
